'use client';

import { c as _c } from "react/compiler-runtime";
import { BuilderBlocks } from '@builder.io/react';
import { useState } from 'react';
import { Button } from '@src/components/Button/Button';
import { Dropdown } from '@src/components/SKUSelectorDropdown/Dropdown';
import { useLoadings } from '@src/hooks/useLoadings';
import { useBreakpoints } from '@src/utils/breakpoints.util';
import type { SKUSelectorDropdownProps } from './SKUSelectorDropdownProps';

/**
 * This component has been extracted from SKUSelectorV2. It's been simplified so its more efficient and easier to use.
 */
export function SKUSelectorDropdown(props) {
  const $ = _c(22);
  const {
    options
  } = props;
  const [selectedSku, setSelectedSku] = useState(options?.[0]?.sku ?? "");
  const isLoading = useLoadings().loadings.isAddingLineItems ?? false;
  const breakpoints = useBreakpoints();
  const isMobile = breakpoints.isMobile || breakpoints.isTablet;
  let t0;
  if ($[0] !== isLoading || $[1] !== props.builderBlock?.id || $[2] !== props.options || $[3] !== props.previewAllItems || $[4] !== selectedSku) {
    t0 = () => {
      const options_0 = (props.options ?? []).map((option, index) => ({
        sku: option.sku ?? "",
        label: option.label ?? "",
        descriptor: option.descriptor ?? "",
        hasImage: option.hasImage ?? false,
        image: option.image,
        contentTop: <BuilderBlocks blocks={option.contentTop} parentElementId={props.builderBlock?.id} dataPath={`component.dropdown[${index}].contentTop`} />
      }));
      const activeOption = options_0.find(option_0 => option_0.sku === selectedSku);
      return <Dropdown dropdownOptions={options_0} activeOption={activeOption} selectedSku={selectedSku} isLoading={isLoading} onChange={setSelectedSku} previewAllItems={props.previewAllItems} />;
    };
    $[0] = isLoading;
    $[1] = props.builderBlock?.id;
    $[2] = props.options;
    $[3] = props.previewAllItems;
    $[4] = selectedSku;
    $[5] = t0;
  } else {
    t0 = $[5];
  }
  const renderDropdown = t0;
  let t1;
  if ($[6] !== renderDropdown) {
    t1 = renderDropdown();
    $[6] = renderDropdown;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  const t2 = props.cta?.variant ?? "primary";
  const t3 = isMobile ? "medium" : "large";
  let t4;
  if ($[8] !== selectedSku) {
    t4 = [{
      sku: selectedSku,
      quantity: 1
    }];
    $[8] = selectedSku;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const t5 = props.cta?.redirectUrl;
  let t6;
  if ($[10] !== t4 || $[11] !== t5) {
    t6 = {
      skus: t4,
      redirectUrl: t5
    };
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const t7 = props.cta?.label;
  let t8;
  if ($[13] !== isLoading || $[14] !== t2 || $[15] !== t3 || $[16] !== t6 || $[17] !== t7) {
    t8 = <Button className="mt-4" isLoading={isLoading} variant={t2} size={t3} actionName="addItemsToCart" addItemsToCart={t6}>{t7}</Button>;
    $[13] = isLoading;
    $[14] = t2;
    $[15] = t3;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t1 || $[20] !== t8) {
    t9 = <div data-testid="sku-selector">{t1}{t8}</div>;
    $[19] = t1;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  return t9;
}